import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WeekComponent } from './forecast/week/week.component';
import { MonthComponent } from './forecast/month/month.component';
import { YearComponent } from './forecast/year/year.component';
import { ProductionBoardComponent } from './production-board/production-board.component';
import { CallersComponent } from './callers/callers.component';
import { BlackOutDaysComponent } from './black-out-days/black-out-days.component';
import { EmployeeUsersComponent } from './employee-users/employee-users.component';
import { ClientUsersComponent } from './client-users/client-users.component';
import { QualityControlComponent } from './quality-control/quality-control.component';
import { FyiDisposComponent } from './fyi-dispos/fyi-dispos.component';
import { RescheduleLeadsComponent } from './reschedule-leads/reschedule-leads.component';
import { ReplacementLeadsComponent } from './replacement-leads/replacement-leads.component';
import { UserEditComponent } from './employee-users/user-edit/user-edit.component';
import { BillingComponent } from './billing/billing.component';
import { ChargebackComponent } from './chargeback/chargeback.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { PermissionsGuard } from '../core/guards/permissions.guard';
import { HistoryComponent } from './forecast/history/history.component';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { CampaignAddComponent } from './campaigns/campaign-add/campaign-add.component';
import { CampaignEditComponent } from './campaigns/campaign-edit/campaign-edit.component';
import { CallerReportsComponent } from './caller-reports/caller-reports.component';
import { DispoReportsComponent } from './dispo-reports/dispo-reports.component';
import { CampaignEffortComponent } from './campaign-effort/campaign-effort.component';
import { LeadRankingComponent } from './lead-ranking/lead-ranking.component';
import { BillingAuthorizeComponent } from './billing-authorize/billing-authorize.component';
import { LeadEditComponent } from '../shared/lead-edit/lead-edit.component';
import { EditClientComponent } from './client-users/edit-client/edit-client.component';
import { ProspectsComponent } from './prospects/prospects.component';
import { ListUploadComponent } from './list-upload/list-upload.component';
import { BillingAuthorizeChaseComponent } from './billing-authorize-chase/billing-authorize-chase.component';
import { CallerTrackingComponent } from './caller-tracking/caller-tracking.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { ArchiveComponent } from './archive/archive.component';
import { CallerTrackingDetailComponent } from './caller-tracking/caller-tracking-detail/caller-tracking-detail.component';
import { BillingReportComponent } from './billing-report/billing-report.component';
import { SupportTicketsComponent } from './support-tickets/support-tickets.component';
import { UsersComponent } from './users/users.component';
import { CommandCenterComponent } from './command-center/command-center.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { VeraAiChatComponent } from './vera-ai-chat/vera-ai-chat.component';
import { NewQcComponent } from './new-qc/new-qc.component';
import { AiAgentsComponent } from './ai-agents/ai-agents.component';

const routes: Routes = [
	{
		// Command Center is the post-login home. CallerTrackingComponent (Live Activity /
		// Caller Tracking) stays reachable at /caller-tracking. '/' has no data.viewId, so
		// PermissionsGuard allows it for all authed users.
		//
		// data.viewId is the MENU id (layouts/sidebar/menu.ts) that PermissionsGuard requires.
		// Sub-views carry the id of the view they belong to; routes without it are open.
		path: 'command-center',
		component: CommandCenterComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 1 },
	},
	{
		path: 'vera-ai',
		component: VeraAiChatComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 24 },
	},
	{
		path: '',
		component: CallerTrackingComponent,
		canActivate: [PermissionsGuard],
	},
	{
		path: 'caller-tracking',
		component: CallerTrackingComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 3 },
	},
	{
		// Individual caller drill-down, reached from the "View" link in the Caller Tracking
		// list. Requires the same permission as /caller-tracking.
		path: 'caller-tracking/:id',
		component: CallerTrackingDetailComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 3 },
	},
	{
		path: 'campaigns',
		component: CampaignsComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 4 },
	},
	{
		path: 'forecast/week',
		component: WeekComponent,
		canActivate: [PermissionsGuard],
	},
	{
		path: 'forecast/month',
		component: MonthComponent,
		canActivate: [PermissionsGuard],
	},
	{
		path: 'forecast/year',
		component: YearComponent,
	},
	{
		path: 'production-board',
		component: ProductionBoardComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 2 },
	},
	{
		path: 'caller-campaigns',
		component: CallersComponent,
	},
	{
		path: 'black-out-days',
		component: BlackOutDaysComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 16 },
	},
	{
		path: 'employee-users',
		component: EmployeeUsersComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 6 },
	},
	{
		path: 'client-users',
		component: ClientUsersComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 6 },
	},
	{
		path: 'edit-client/:user_id',
		component: EditClientComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 6 },
	},
	{
		path: 'callers-reports',
		component: CallerReportsComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 10 },
	},
	{
		path: 'dispo-reports',
		component: DispoReportsComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 11 },
	},
	{
		path: 'campaign-effort',
		component: CampaignEffortComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 23 },
	},
	{
		path: 'lead-ranking',
		component: LeadRankingComponent,
		canActivate: [PermissionsGuard],
	},
	{
		path: 'quality-control',
		component: QualityControlComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 9 },
	},
	{
		path: 'fyi-dispos',
		component: FyiDisposComponent,
		canActivate: [PermissionsGuard],
	},
	{
		path: 'reschedule-leads',
		component: RescheduleLeadsComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 17 },
	},
	{
		path: 'replacement-leads',
		component: ReplacementLeadsComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 18 },
	},
	{
		path: 'list-upload',
		component: ListUploadComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 20 },
	},
	{
		path: 'user-edit',
		component: UserEditComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 6 },
	},
	{
		path: 'lead-edit/:selectedLead',
		component: LeadEditComponent,
	},
	{
		path: 'billing',
		component: BillingComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 14 },
	},
	{
		path: 'billing-authorize',
		component: BillingAuthorizeComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 14 },
	},
	{
		path: 'billing-authorize-chase',
		component: BillingAuthorizeChaseComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 14 },
	},
	{
		path: 'chargebacks',
		component: ChargebackComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 14 },
	},
	{
		path: 'forecast/history',
		component: HistoryComponent,
		canActivate: [PermissionsGuard],
	},
	{
		path: 'campaign-add',
		component: CampaignAddComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 4 },
	},
	{
		path: 'campaign-edit',
		component: CampaignEditComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: [4, 14] },
	},
	{
		path: 'prospects',
		component: ProspectsComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 21 },
	},
	{
		path: 'permissions',
		component: PermissionsComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 7 },
	},
	{
		path: 'access-denied',
		component: NotAuthorizedComponent,
	},
	{
		path: 'archive',
		component: ArchiveComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 22 },
	},
	{
		path: 'billing-report',
		component: BillingReportComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 14 },
	},
	{
		path: 'support-tickets',
		component: SupportTicketsComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 19 },
	},
	{
		path: 'users',
		component: UsersComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 6 },
	},
	{
		path: 'notifications',
		component: NotificationsComponent,
	},
	{
		path: 'new-qc',
		component: NewQcComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 25 },
	},
	{
		path: 'ai-agents',
		component: AiAgentsComponent,
		canActivate: [PermissionsGuard],
		data: { viewId: 26 },
	}
];

@NgModule({
	declarations: [],
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class ViewsRoutingModule {}
